import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { masterConfigurationList } from 'src/app/constants/masterConfigList';
import { LoaderHandlerService, ServicecallService } from 'src/app/services';

@Component({
  selector: 'app-external-initialization',
  templateUrl: './external-initialization.component.html',
  styleUrls: ['./external-initialization.component.css']
})
export class ExternalInitializationComponent implements OnInit, OnDestroy {
  isUrlIdAvailable: boolean = false;
  isError: boolean = false;
  private _externalToken: string;
  private _paramMapSubscription: Subscription;
  private _externalAuthenticationSubscription: Subscription;
  private _configurationsInfoSubscription: Subscription;
  private _getTranslateSubscription: Subscription;

  constructor(
    private _Activatedroute: ActivatedRoute,
    private _service: ServicecallService,
    private _router: Router,
    private _loaderHandler: LoaderHandlerService) { }

  ngOnInit(): void {
    this._paramMapSubscription = this._Activatedroute.paramMap.subscribe(params => {
      if (params.get('id')) {
        this.isUrlIdAvailable = true;
        localStorage.clear();
        sessionStorage.clear();
        this._externalToken = params.get('id');
        this._externalLogin()
      } else {
        this.isUrlIdAvailable = false;
      }
    });
  }
  ngOnDestroy(): void {
    this._paramMapSubscription?.unsubscribe();
    this._externalAuthenticationSubscription?.unsubscribe();
    this._configurationsInfoSubscription?.unsubscribe();
    this._getTranslateSubscription?.unsubscribe();

  }
  private _externalLogin() {
    this._externalAuthenticationSubscription = this._service.externalAuthentication(this._externalToken).subscribe(
      {
        next: (response: any) => {
          localStorage.setItem("tenantId", response?.['tenantId']);
          localStorage.setItem("domain", response?.['domain'] ? response?.['domain'] : null);
          localStorage.setItem("token", response?.['token']);
          localStorage.setItem("credId", response?.['credId']);
          localStorage.setItem("userId", response?.['userId']);
          localStorage.setItem("username", response?.['userName']);
          response?.['idmUserName'] ? localStorage.setItem("idmUserName", response?.['idmUserName']) : '';
          localStorage.setItem("index", response?.['index']);
          localStorage.setItem("userFullName", response?.['name'] ? (response['name']?.first ? response['name']?.first : '') : '');
          localStorage.setItem("userImg", JSON.stringify(response?.['image']));
          localStorage.setItem("cid", response?.['clientId']);
          localStorage.setItem("entityIds", response?.['entityIds']?.length ? JSON.stringify(response['entityIds']) : null);
          localStorage.setItem("roleId", response?.['roleId']);
          localStorage.setItem("layouts", response?.['layouts'] ? JSON.stringify(response?.['layouts']) : null);
          this._configurationsInfoSubscription = this._service.configurationsInfo(masterConfigurationList, false).subscribe((data: any) => {
            let mappedConfigList = [];
            if (data.status) {
              if (data.response.length) {
                mappedConfigList = data.response.map((item: any) => {
                  const obj = {};
                  obj['attribute'] = item.attribute;
                  obj['values'] = item.values;
                  obj['_id'] = item._id;
                  return obj;
                });
              }
              this._service.setConfiguration(mappedConfigList);
              if (this._service.getConfiguration('translation') && Object.keys(this._service.getConfiguration('translation'))?.length) {
                localStorage.setItem("trans", JSON.stringify(this._service.getConfiguration('translation')['menu']));
              } else {
                this._getTranslateSubscription = this._service.getTranslate('sim').subscribe((item: any) => {
                  this._loaderHandler.toggleLoader(0);
                  localStorage.setItem("trans", JSON.stringify(item['menu']));
                });
              }
              // if (this._service.getPrivilegeUrl()) {
              //   this._router.navigateByUrl(this._getRedirectUrl(response));
              // } else {
              //   this._service.toasterService({ type: 'warning', msg: 'Sorry, you dont have relevant privilege to access the portal. Please contact admin and try again.' });
              // }
              this._service.setRbacList(false, response);
            } else {
              this._service.toasterService({ type: 'error', msg: data?.response?.message });
              this._service.setConfiguration(mappedConfigList);
            }
            if (!mappedConfigList.length) {
              this._service.toasterService({ type: 'warning', msg: 'Configuration is not available, please provide the required configuration for the app' });
            }
          });
          this.isError = false;
        },
        error: () => {
          this.isError = true;
        }
      });
  }

  // private _getRedirectUrl(details: any) {
  //   switch (details?.['entityType']) {
  //     case 1: return 'vehicles/profile/' + details?.['redirectTo'];
  //     case 2: return 'assets/profile/' + details?.['redirectTo'];
  //     case 3: return 'people/profile/' + details?.['redirectTo'];
  //     default: return 'home';
  //   }
  // }
}
